import { isUndefined } from 'lodash';

import { formatDuration } from '@air/utilities';

export const formatDiscussionTimestamp = ({
  endTimestamp,
  timestamp,
}: {
  endTimestamp?: number;
  timestamp: number;
}) => {
  if (isUndefined(endTimestamp)) {
    return formatDuration(Math.round(timestamp));
  }

  const startTime = Math.min(timestamp, endTimestamp);
  const endTime = Math.max(timestamp, endTimestamp);

  return `${formatDuration(Math.round(startTime))} - ${formatDuration(Math.round(endTime))}`;
};
